module.exports = __webpack_public_path__ + "static/media/StartBlockTarget.012c37bd.svg";